var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronForward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2486_202555",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2486_202555)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9984 11.9984L9.64844 7.64844C9.58177 7.58177 9.54427 7.5026 9.53594 7.41094C9.5276 7.31927 9.5651 7.23177 9.64844 7.14844C9.73177 7.0651 9.8151 7.02344 9.89844 7.02344C9.98177 7.02344 10.0651 7.0651 10.1484 7.14844L14.4734 11.4734C14.5568 11.5568 14.6151 11.6401 14.6484 11.7234C14.6818 11.8068 14.6984 11.8984 14.6984 11.9984C14.6984 12.0984 14.6818 12.1901 14.6484 12.2734C14.6151 12.3568 14.5568 12.4401 14.4734 12.5234L10.1484 16.8484C10.0818 16.9151 10.0026 16.9526 9.91094 16.9609C9.81927 16.9693 9.73177 16.9318 9.64844 16.8484C9.5651 16.7651 9.52344 16.6818 9.52344 16.5984C9.52344 16.5151 9.5651 16.4318 9.64844 16.3484L13.9984 11.9984Z",
    fill: "#053692"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronForward);
export default __webpack_public_path__ + "static/media/chevron_forward.9ea6876efb9b86cc05b8e7df6ad92f81.svg";
export { ForwardRef as ReactComponent };